
export const APP_VERSION = '5.102.9';
export const BUILD_TIME = '10/26/2026, 6:41:48 PM';
